import t from"@babel/runtime/helpers/slicedToArray";import{useState as r}from"react";function n(){var n=r(!1),e=t(n,2),o=e[0],i=e[1];return{isAnnotationsListOpened:o,toggleAnnotationsList:function(){return i(!o)}}}export{n as default};
